window.addEventListener("DOMContentLoaded", function () {
  const videoModalButton = document.querySelector(".video-modal-button");

  videoModalButton.addEventListener("click", (e) => {
    e.preventDefault();
    const [videoModal] = document.getElementsByClassName("video-modal");
    videoModal.classList.add("is-visible");
  });

  const [videoModalClose] = document.getElementsByClassName(
    "video-modal-content_close"
  );
  videoModalClose.addEventListener("click", () => {
    const [videoModal] = document.getElementsByClassName("video-modal");
    const video = document.getElementById("klima-video");
    video?.pause();
    videoModal.classList.remove("is-visible");
  });
});
